import { getCareerFromKey } from "enefel/race";
import { getSkillDisplayedWithCarrer, isSpecialSkill } from "enefel/skill";
import React from "react";
import Skill from "./Skill";
import SpecialSkills from "./SpecialSkills";

type SkillsProps = {
  playerId?: any;
  careerId?: any;
  skills?: any[];
  separator?: React.ReactNode;
  empty?: React.ReactNode;
  hide?: any[];
  displaySpecial?: boolean;
};

const Skills: React.FC<SkillsProps> = React.memo(
  ({
    playerId = null,
    careerId = null,
    skills = [],
    separator = <br />,
    empty = "None",
    hide = getSkillDisplayedWithCarrer(), // hide big guy, specialist etc...
    displaySpecial = true,
  }) => {
    let raceSkills = [];
    if (careerId) {
      const career = getCareerFromKey(careerId);
      raceSkills = career ? career.skills : [];
    }

    const list = skills
      .filter((s) => !isSpecialSkill(s))
      .map((s) => {
        let info = null;
        if (Array.isArray(s)) {
          info = s[1];
          s = s[0];
        }
        const key = `${s.skill_id ? s.skill_id : s}-${playerId}-${s.info}`;
        const isNew =
          careerId && raceSkills !== undefined
            ? !raceSkills.some(
                (r) =>
                  r === s.skill_id || (Array.isArray(r) && r[0] === s.skill_id)
              )
            : false;

        return (
          <Skill
            key={key}
            skill={s}
            isNew={isNew}
            info={info || s.info}
            withDate={true}
          />
        );
      });
    const listSkills =
      list && list.length
        ? (
            <>
              {list.map((el, i) => (
                <React.Fragment key={`${i}-skill-${playerId}`}>
                  {i > 0 && separator}
                  {el}
                </React.Fragment>
              ))}
            </>
          )
        : empty;

    return (
      <>
        {listSkills && <div>{listSkills}</div>}
        {displaySpecial && (
          <div>
            <SpecialSkills
              playerId={playerId}
              careerId={careerId}
              separator={separator}
              skills={skills}
              hide={hide}
            />
          </div>
        )}
      </>
    );
  }
);

export default Skills;
